export default __webpack_public_path__ + "static/media/558005918865.faab99cf.svg";